// datatable related plugins
import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { env } from "configs/EnvironmentConfig";
import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
  TYPE_TRANSFER,
} from "constants/FormatDataContanst";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { getResourceIdXML } from "helpers/form_helper";
import { getFileNameExcel, toastWarningIsAllStore } from "helpers/utils";
import jwt_decode from "jwt-decode";
import ErrorReleaseModal from "pages/DataFormatInvoice/modal/ErrorReleaseModal";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Badge, Button, Card, CardBody, Col, Row } from "reactstrap";
import {
  downloadXmlErrorInvoices,
  errorInvoicesDelete,
  exportInvoice,
  getListErrorInvoices,
  releaseErrorInvoices,
  resetdownloadPDFInvoices,
  resetDownloadXmlErrorInvoices,
  resetEditErrorInvoices,
  resetErrorInvoicesDelete,
  resetExportInvoice,
  resetListErrorInvoices,
  resetPreviewPdfErrorInvoice,
  resetReleaseErrorInvoices,
  setColumnVisibleRegistryInvoices,
} from "store/actions";
import {
  AUTH_TOKEN,
  ROLE_EINVOICE_CUA_HANG,
} from "store/auth/login/actionTypes";
import {
  DOWNLOAD_PDF_REGISTRY_INVOICES_FAIL,
  DOWNLOAD_PDF_REGISTRY_INVOICES_SUCCESS,
} from "store/data-format/actionTypes";
import {
  DOWNLOAD_XML_ERROR_INVOICES_FAIL,
  DOWNLOAD_XML_ERROR_INVOICES_SUCCESS,
  ERROR_INVOICES_DELETE_FAIL,
  ERROR_INVOICES_DELETE_SUCCESS,
  PREVIEW_PDF_ERROR_INVOICE_FAIL,
  PREVIEW_PDF_ERROR_INVOICE_SUCCESS,
} from "store/error-invoices/actionTypes";
import {
  EXPORT_INVOICE_FAIL,
  EXPORT_INVOICE_SUCCESS,
} from "store/issue-invoice/actionTypes";
import DetailDataModal from "./DetailDataModal";
import DetailDataModalV2 from "./DetailDataModalV2";
import { getStatus } from "./helper/functionHelper";
import ListHDonModal from "./ListHDonModal";
import HistoryTransferModal from "./modal/HistoryTransferModal";
import PDFViewModal from "./modal/PDFViewDownloadModal";
import SignHSMModal from "./modal/SignHSMModal";
import TypeSignDigitalModal from "./modal/TypeSignDigitalModal";
import VerifyPinUSBModal from "./modal/VerifyPinUSBModal";
import {
  IS_POS_LABEL,
  LADHDDT_LABEL,
  LCTDT_LABEL,
  MODE,
  tableFormateDate,
} from "./utils";

const ListData = props => {
  const { isTaxDeduct = false } = props;
  const object = isTaxDeduct ? "Chứng từ" : "Hóa đơn";

  const { addToast } = useToasts();
  const history = useHistory();
  // modalErrorRelease
  const [idRelease, setIdRelease] = useState(null);
  const [modalErrorRelease, setModalErrorRelease] = useState(false);
  const toggleErrorReleaseModal = () =>
    setModalErrorRelease(!modalErrorRelease);
  const [modalHistoryTransfer, setModalHistoryTransfer] = useState(false);
  const toggleHistoryTransferModal = () =>
    setModalHistoryTransfer(!modalHistoryTransfer);
  const [idHistory, setIdHistory] = useState(null);
  // Modal detail
  const [detailData, setDetailData] = useState(null);
  const [modalDetail, setModalDetail] = useState(false);
  const toggleDetailModal = () => setModalDetail(!modalDetail);
  // Modal detail tax deduct
  const [detailDataTaxDeduct, setDetailDataTaxDeduct] = useState(null);
  const [modalDetailDataTaxDeduct, setModalDetailDataTaxDeduct] =
    useState(false);
  const toggleDetailDataTaxDeductModal = () =>
    setModalDetailDataTaxDeduct(!modalDetailDataTaxDeduct);
  // Modal listHDOn
  const [dataListHDon, setDataListHDon] = useState(null);
  const [modalListHDon, setModalListHDon] = useState(false);
  // modalPDFView
  const [modalPdfView, setModalPdfView] = useState(false);
  const togglePdfViewModal = () => setModalPdfView(!modalPdfView);
  const toggleListHDonModal = () => setModalListHDon(!modalListHDon);
  // toggleSendMailModal
  const [modalSendMail, setModalSendMail] = useState(false);
  const toggleSendMailModal = () => setModalSendMail(!modalSendMail);
  const [mailData, setMailData] = useState({
    idInvoice: null,
    mailDefault: null,
  });
  const showSendMail = row => {
    setMailData({
      idInvoice: row.id,
      mailDefault: "",
    });
    toggleSendMailModal();
  };

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  // store reducer
  const errorInvoices = useSelector(state => state.errorInvoices);
  const {
    fileDownload,
    fileDownloadName,
    type,
    previewPdfErrorFile,
    edit: errorInvoicesEdit,
    errorInvoicesDeleteData,
  } = errorInvoices;
  const { loading, listData, totalCount, columnsVisible, params } =
    errorInvoices.notificationErrorInvoices;

  const issueInvoice = useSelector(state => state.issueInvoice);
  const {
    exportInvoiceData,
    type: typeIssueInvoice,
    fileDownload: fileDownloadIssueInvoice,
    fileDownloadName: fileDownloadNameIssueInvoice,
    bkDataNew,
  } = issueInvoice;

  const dataFormat = useSelector(state => state.dataFormat);
  const {
    previewPdfRegisterFile,
    type: typePDF,
    fileDownload: fileDownloadPDF,
    fileDownloadName: fileDownloadNamePDF,
  } = dataFormat;
  const { t, i18n } = useTranslation(["errorInvoice"]);

  const [commonStatus, setCommonStatus] = useState(getStatus(t));
  const [dataViewDocument, setDataViewDocument] = useState(null);
  useEffect(() => {
    setCommonStatus(getStatus(t));
  }, [t]);

  const fetchList = paramsFetch => {
    dispatch(
      getListErrorInvoices({
        ...paramsFetch,
        isTaxDeduct,
      })
    );
  };

  useEffect(() => {
    switch (typeIssueInvoice) {
      case EXPORT_INVOICE_SUCCESS: {
        if (fileDownloadIssueInvoice !== null) {
          const link = document.createElement("a");
          link.href = fileDownloadIssueInvoice;
          link.setAttribute("download", fileDownloadNameIssueInvoice);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetExportInvoice());
        break;
      }
      case EXPORT_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetExportInvoice());
        break;
      default:
        break;
    }
  }, [typeIssueInvoice]);

  // modalTypeSign
  const [transferData, setTransferData] = useState(null);
  const [modalTypeSign, setModalTypeSign] = useState(false);
  const toggleTypeSignModal = () => setModalTypeSign(!modalTypeSign);

  // modalUSB
  const [modalUSBSign, setModalUSBSign] = useState(false);
  const toggleUSBSignModal = () => setModalUSBSign(!modalUSBSign);

  // modalHSM
  const [modalHSMSign, setModalHSMSign] = useState(false);
  const toggleHSMSignModal = () => setModalHSMSign(!modalHSMSign);

  // Confirm Delete modal
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const toggleConfirmDeleteModal = () =>
    setModalConfirmDelete(!modalConfirmDelete);

  const Dashboard = useSelector(state => state.Dashboard);

  const {
    tenantCodeHeader,
    buStoreHeader,
    finalBuInfo,
  } = Dashboard;

  useEffect(() => {
    switch (type) {
      case DOWNLOAD_XML_ERROR_INVOICES_SUCCESS: {
        if (!modalUSBSign) {
          if (fileDownload !== null) {
            const link = document.createElement("a");
            link.href = fileDownload;
            link.setAttribute("download", fileDownloadName);
            document.body.appendChild(link);
            link.click();
          }
          addToast("Tải xuống thành công", {
            appearance: "success",
            autoDismiss: true,
          });
        }
        dispatch(resetDownloadXmlErrorInvoices());
        break;
      }
      case DOWNLOAD_XML_ERROR_INVOICES_FAIL:
        if (!modalUSBSign) {
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetDownloadXmlErrorInvoices());
        break;
      case PREVIEW_PDF_ERROR_INVOICE_SUCCESS: {
        if (!modalPdfView) {
          if (previewPdfErrorFile !== null) {
            const link = document.createElement("a");
            link.href = previewPdfErrorFile.data;
            link.setAttribute("download", "error-invoice.pdf");
            document.body.appendChild(link);
            link.click();
          }
          addToast("Tải xuống thành công", {
            appearance: "success",
            autoDismiss: true,
          });
          dispatch(resetPreviewPdfErrorInvoice());
        }
        break;
      }
      case PREVIEW_PDF_ERROR_INVOICE_FAIL:
        if (!modalPdfView) {
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
          dispatch(resetPreviewPdfErrorInvoice());
        }
        break;
      case ERROR_INVOICES_DELETE_SUCCESS: {
        addToast("Xóa thông báo thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleConfirmDeleteModal();
        fetchList(params);
        dispatch(resetErrorInvoicesDelete());
        break;
      }
      case ERROR_INVOICES_DELETE_FAIL:
        addToast("Xóa thông báo thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetErrorInvoicesDelete());
        break;
      default:
        break;
    }
  }, [type]);

  // Action Dispatch
  useEffect(() => {
    if (errorInvoicesEdit && errorInvoicesEdit.success) {
      addToast(
        t("message.update", {
          target: isTaxDeduct ? t("error_tax_deduct") : t("error_invoice"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      dispatch(resetEditErrorInvoices());
      fetchList(params);
      if (isTaxDeduct) {
        toggleDetailDataTaxDeductModal();
      } else {
        toggleDetailModal();
      }
    }
  }, [errorInvoicesEdit]);

  useEffect(() => {
    if (finalBuInfo) {
      params.page = 1;
      fetchList(params);
    }
  }, [finalBuInfo]);

  //ROLE_EINVOICE_CUA_HANG thì ẩn nút phát hành
  const [isRoleStore, setIsRoleStore] = useState(false);

  useEffect(() => {
    const info = localStorage.getItem(AUTH_TOKEN)
      ? jwt_decode(localStorage.getItem(AUTH_TOKEN))
      : null;
    const roleUser = info?.["auth"];
    if (roleUser) {
      const listRole = info["auth"].split(",");
      setIsRoleStore(
        listRole.findIndex(item => item === ROLE_EINVOICE_CUA_HANG) !== -1
          ? true
          : false
      );
    }
    return () => {
      dispatch(resetListErrorInvoices());
    };
  }, []);

  const initColumn = () => {
    if (Object.keys(columnsVisible).length !== 0) {
      for (const item of initColumns) {
        if (columnsVisible[item.dataField] !== undefined) {
          item.hidden = !columnsVisible[item.dataField];
        }
      }
    }
    setColumns(initColumns);
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      if (isTaxDeduct) {
        setDetailDataTaxDeduct({ ...row, mode: MODE.VIEW });
        toggleDetailDataTaxDeductModal();
      } else {
        setDetailData({ ...row, mode: MODE.VIEW });
        toggleDetailModal();
      }
      //   setDataDetail({
      //     content: row.content,
      //     file_name: row.file_name,
      //     process_upload_id: row.id,
      //     status: row.status,
      //   });
      //   setDataDetail({ id: row.id, mode: MODE_FORM.VIEW });
      //   toggleViewDetailModal();
    },
  };

  //path: approve-pdf
  //      review-pdf
  const showPdfById = (row, path = "review-pdf") => {
    setDataViewDocument({
      id: row.id,
      path,
      fileName:
        path === "review-pdf"
          ? `Bản hiển thị ${object} sai sót (${row.id})`
          : `Kết quả xử lý ${object} sai sót (${row.id})`,
    });
    togglePdfViewModal();
  };
  const listRowAction = useMemo(() => {
    if (!buStoreHeader) {
      return [];
    }
    const listAction = [
      {
        icon: <i className="bx bxs-file-pdf text-danger" />,
        isDropdown: true,
        classDropdown: "dropdown-menu-3",
        conditionVisible: {
          resource_id: [],
          auth_status: [AUTH_STATUS_APPROVE],
        },
        listDropdown: [
          {
            text: "Bản hiển thị",
            icon: <i className="bx bxs-file-pdf text-primary" />,
            onClick: row => {
              showPdfById(row);
            },
          },
          {
            conditionVisible: {
              auth_status: [AUTH_STATUS_APPROVE],
            },
            text: "Kết quả xử lý",
            icon: <i className="bx bxs-file-pdf text-success" />,
            onClick: row => {
              showPdfById(row, "approve-pdf");
            },
          },
        ],
        text: "Xem file PDF",
      },
      {
        icon: <i className="bx bx-trash font-size-18 text-danger" />,
        text: "Xóa",
        isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
        conditionVisible: {
          auth_status: [AUTH_STATUS_NEW],
        },
        onClick: row => {
          setDataViewDocument({
            id: row.id,
          });
          toggleConfirmDeleteModal();
        },
      },
      {
        icon: <i className="bx bx-send font-size-18 text-success" />,
        text: "Gửi duyệt thông báo",
        isShow:
          buStoreHeader !== ALL_STORE &&
          buStoreHeader !== ALL_BU &&
          !isRoleStore,
        conditionVisible: {
          resource_id: [],
          auth_status: [AUTH_STATUS_NEW, AUTH_STATUS_RR],
        },
        onClick: row => {
          if (toastWarningIsAllStore(addToast)) {
            return;
          }
          setTransferData({
            id: row.id,
            mst: row.mst,
            resource_id: getResourceIdXML(row.resource_list, "raw"),
            type: TYPE_TRANSFER.HDSS,
          });
          toggleTypeSignModal();
        },
      },
      {
        icon: <i className="bx bx-mail-send text-success" />,
        text: "Gửi mail",
        isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
        conditionVisible: {
          auth_status: [AUTH_STATUS_APPROVE],
        },
        onClick: row => {
          showSendMail(row);
        },
      },
      {
        icon: <i className="bx bx-download font-size-18 text-primary" />,
        text: "Download XML",
        conditionVisible: {
          resource_id: [],
        },
        onClick: row => {
          let resource_id = null;
          let type = "";
          if (row.auth_status === AUTH_STATUS_NEW) {
            type = "raw";
          } else if (row.auth_status === AUTH_STATUS_APPROVE) {
            type = "tct-response";
          } else {
            type = "signed";
          }
          resource_id = getResourceIdXML(row.resource_list, type);
          if (resource_id) {
            dispatch(
              downloadXmlErrorInvoices(
                resource_id,
                row.ten,
                "blob",
                isTaxDeduct
              )
            );
          } else {
            addToast("Tải xuống thất bại", {
              appearance: "error",
              autoDismiss: true,
            });
          }
        },
      },
      {
        icon: <i className="bx bx-history font-size-18 text-success" />,
        text: "Lịch sử truyền nhận",
        onClick: row => {
          setIdHistory(row.id);
          toggleHistoryTransferModal();
        },
      },
      // {
      //   icon: <i className="bx bx-edit font-size-18 text-success" />,
      //   text: "Cập nhật",
      //   conditionVisible: {
      //     auth_status: [AUTH_STATUS_NEW],
      //   },
      //   onClick: row => {},
      // },

      {
        icon: <i className="bx bx-edit font-size-18 text-success" />,
        text: "Cập nhật thông báo",
        isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
        conditionVisible: {
          auth_status: [AUTH_STATUS_NEW],
        },
        onClick: row => {
          if (isTaxDeduct) {
            setDetailDataTaxDeduct({ ...row, mode: MODE.EDIT });
            toggleDetailDataTaxDeductModal();
          } else {
            setDetailData({ ...row, mode: MODE.EDIT });
            toggleDetailModal();
          }
        },
      },
      {
        icon: <i className="bx bxs-file-pdf font-size-18 text-danger" />,
        text: "Xem trước bản hiển thị",
        conditionVisible: {
          auth_status: [
            AUTH_STATUS_NEW,
            AUTH_STATUS_PROGRESSING,
            AUTH_STATUS_AR,
            AUTH_STATUS_REJECT,
            AUTH_STATUS_RR,
          ],
        },
        onClick: row => {
          showPdfById(row);
        },
      },
    ];
    console.log("Thông tin danh sách thao tác", { listAction });
    return listAction;
  }, [buStoreHeader, isRoleStore]);

  const selectFilterLoai = {
    1: "Thông báo hủy/giải trình của NNT",
    2: "Thông báo hủy/giải trình của NNT theo thông báo của CQT",
  };

  const getAuthStatus = (status, id) => {
    let infoError = null;
    if (
      status === AUTH_STATUS_REJECT ||
      status === AUTH_STATUS_RRE ||
      status === AUTH_STATUS_RR
    ) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setIdRelease(id);
            toggleErrorReleaseModal();
          }}
        ></i>
      );
    }
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[status]?.text}
          </Badge>
          {infoError}
        </div>
      </React.Fragment>
    );
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Chờ phát hành",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Đã phát hành",
    [AUTH_STATUS_AR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_AR]?.text, // Đã tiếp nhận đăng ký
    // [AUTH_STATUS_ARE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_ARE]?.text, // Đã tiếp nhận thay đổi

    [AUTH_STATUS_REJECT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT]?.text, // "Từ chối phát hành",
    [AUTH_STATUS_RR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RR]?.text, //"Từ chối tiếp nhận đăng ký",
    // [AUTH_STATUS_RRE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RRE]?.text, //"Từ chối tiếp nhận thay đổi"
  };

  const initColumns = [
    {
      dataField: "id",
      text: "id",
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { minWidth: "75px" },
      }),
      hidden: env.API_AIR_BRAKE_ENV !== "dev",
    },
    ...(!isTaxDeduct
      ? [
          {
            dataField: "is_pos",
            text: "Loại áp dụng hóa đơn điện tử",
            sort: true,
            formatter: (cell, row) => {
              return IS_POS_LABEL[cell] || cell;
            },
            filter: selectFilter({
              placeholder: "Chọn",
              options: IS_POS_LABEL,
            }),
          },
        ]
      : []),
    {
      dataField: "bu_code",
      text: "Mã đơn vị",
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
      hidden: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
    },
    // {
    //   dataField: "pban",
    //   text: t("field.pban"),
    //   hidden: false,
    //   filter: textFilter({
    //     placeholder: "Nhập",
    //   }),
    // },
    {
      dataField: isTaxDeduct ? "dsctu" : "dshdon",
      fieldSearch: isTaxDeduct ? "sctu" : "shdon",
      text: `Danh sách ${object}`,
      hidden: false,
      formatter: (cellContent, row) => {
        if (cellContent?.length > 1) {
          return (
            <div
              style={{ cursor: "pointer" }}
              className="text-center text-info"
              onClick={() => {
                setDataListHDon({ row: row, cellContent: cellContent });
                toggleListHDonModal();
              }}
            >
              Hiển thị danh sách
            </div>
          );
        } else if (cellContent?.length === 1) {
          let item = cellContent[0];
          let KHHDON = "Ký hiệu HĐ: " + item.KHMSHDon + item.KHHDon;
          let SHDon = "Số HĐ: " + item.SHDon;
          if (isTaxDeduct) {
            KHHDON = "Ký hiệu CT: " + item.KHCTu;
            SHDon = "Số CT: " + item.SCTu;
          }
          return (
            <div
              style={{ cursor: "pointer" }}
              className="text-left text-info"
              onClick={() => {
                setDataListHDon({ row: row, cellContent: cellContent });
                toggleListHDonModal();
              }}
            >
              <div>{SHDon}</div>
              <div>{KHHDON}</div>
            </div>
          );
        }
      },
      filter: textFilter({
        placeholder: `Nhập ${isTaxDeduct ? "số chứng từ" : "số hóa đơn"}`,
      }),
    },
    {
      dataField: "ten",
      text: "Tên",
      hidden: false,
      formatter: (cellContent, row) => (
        <div style={{ width: "200px", whiteSpace: "initial" }}>{row.ten}</div>
      ),
      //   filter: textFilter({
      //     placeholder: "Nhập",
      //   }),
    },
    {
      dataField: "auth_status",
      text: "Trạng thái",
      hidden: false,
      formatter: (cellContent, row) => getAuthStatus(row.auth_status, row.id),
      filter: selectFilter({
        placeholder: "Chọn",
        options: selectFilterAuthStatus,
      }),
    },
    ...(!isTaxDeduct
      ? [
          {
            dataField: "stbao_so",
            text: "Số thông báo từ CQT",
            hidden: false,
            filter: textFilter({
              placeholder: "Nhập",
            }),
          },
          {
            dataField: "mhso",
            text: "Mã hồ sơ",
            hidden: false,
          },
          {
            dataField: "hthuc",
            text: "Hình thức của chữ ký",
            hidden: false,
          },
          {
            dataField: "cdanh",
            text: "Chức danh của chữ ký",
            hidden: false,
          },
          {
            dataField: "stbao_ntbao",
            text: "Ngày CQT duyệt",
            hidden: false,
            formatter: (cellContent, row) => tableFormateDate(row.stbao_ntbao),
            filter: customFilter({
              type: CUSTOM_DATE_FILTER_TABLE_TYPE,
            }),
            filterRenderer: (onFilter, column) => (
              <CustomDateFilter
                onFilter={onFilter}
                column={column}
                paramFilter={params.columnFilter}
              />
            ),
          },
        ]
      : []),
    {
      dataField: "mso",
      text: "Mẫu số thông báo",
      hidden: false,
      filter: textFilter({
        placeholder: "Nhập",
      }),
    },
    {
      dataField: "ntbao",
      text: "Ngày thông báo",
      hidden: false,
      formatter: (cellContent, row) => tableFormateDate(row.ntbao),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
    {
      dataField: isTaxDeduct ? "lctdt" : "ladhddt",
      text: `Loại ${object}`,
      hidden: false,
      formatter: (cellContent, row) => {
        return isTaxDeduct
          ? LCTDT_LABEL[row.lctdt]
          : LADHDDT_LABEL[row.ladhddt];
      },
      filter: selectFilter({
        placeholder: "Chọn",
        options: isTaxDeduct ? LCTDT_LABEL : LADHDDT_LABEL,
      }),
    },
    {
      dataField: "loai",
      text: "Loại thông báo",
      hidden: false,
      formatter: (cellContent, row) => {
        let text = "";
        switch (cellContent) {
          case 1:
            text = "Thông báo hủy/giải trình của NNT";
            break;
          case 2:
            text = "Thông báo hủy/giải trình của NNT theo thông báo của CQT";
            break;
          default:
            break;
        }
        return text;
      },
      filter: selectFilter({
        placeholder: "Chọn",
        options: selectFilterLoai,
      }),
    },
    {
      dataField: "tnnt",
      text: "Tên người nộp thuế",
      hidden: false,
      filter: textFilter({
        placeholder: "Nhập",
      }),
    },
    {
      dataField: "mst",
      text: "MST",
      hidden: false,
      filter: textFilter({
        placeholder: "Nhập",
      }),
    },
    {
      dataField: "tcqt",
      text: "Tên cơ quan thuế",
      hidden: false,
      filter: textFilter({
        placeholder: "Nhập",
      }),
    },
    {
      dataField: "mcqt",
      text: "Mã cơ quan thuế",
      hidden: false,
      filter: textFilter({
        placeholder: "Nhập",
      }),
    },
  ];

  const listMultipleRowAction = [
    {
      icon: <i className="far fa-file-excel font-size-18 text-success" />,
      text: `Xuất danh sách ${object} sai sót`,
      isLoading: exportInvoiceData.loading,
      loadingText: `Đang xuất danh sách ${object} sai sót`,
      onClick: data => {
        let objectExport = exportFormatData();
        objectExport = {
          ...objectExport,
          ...params.columnFilter,
          sort: params.sort ? params.sort : "-checker_date",
          keywords: params.keywords,
        };
        dispatch(
          exportInvoice(
            objectExport,
            getFileNameExcel(`DanhSach${object}SaiSot`),
            isTaxDeduct ? "tax-deduct-errors" : "invoice-errors"
          )
        );
      },
    },
  ];

  const formatDataHandle = (objectExport, dataField) => {
    switch (dataField) {
      case "ttchung_shdon":
        objectExport[`columns[${dataField}][label]`] = "Số HĐ";
        break;
      case "ttchung_khhdon":
        objectExport[`columns[${dataField}][label]`] = "Ký hiệu HĐ";
        break;
      case "ttchung_nlap":
        objectExport[`columns[${dataField}][label]`] = "Ngày lập";
        break;
      case "mcqtcap":
        objectExport[`columns[${dataField}][label]`] = "Mã CQT cấp";
        break;
      case "ldo":
        objectExport[`columns[${dataField}][label]`] = "Lí do";
        break;
      case "auth_status":
        for (const key in selectFilterAuthStatus) {
          objectExport[`columns[${dataField}][mapping][${key}]`] =
            selectFilterAuthStatus[key];
        }
        break;
      case "ttchung_khmshdon":
        objectExport[`columns[${dataField}][mapping][1]`] = "HÓA ĐƠN GTGT";
        objectExport[`columns[${dataField}][mapping][2]`] = "HÓA ĐƠN BH";
        break;
      case "ttchung_shdon":
        objectExport[`columns[${dataField}][mapping][null]`] = "Chờ cấp số";
        break;
      case "ntbao":
        objectExport[`columns[${dataField}][type]`] = "date";
        break;
      default:
        break;
    }
    // Format style
    switch (dataField) {
      case "nmua_ten":
        objectExport[
          `columns[${dataField}][contentOptions][alignment][wrapText]`
        ] = true;
        objectExport[`columns[${dataField}][dimensionOptions][width]`] = 80;
        break;
      default:
        objectExport[
          `columns[${dataField}][dimensionOptions][autoSize]`
        ] = true;
        break;
    }
  };

  const exportFormatData = () => {
    let objectExport = {};
    columns
      .filter(item => item.hidden === false || item.hidden === undefined)
      .map(item => {
        const formatData = {
          id: item.id,
          dataField: item.dataField,
          hidden: item.hidden,
          text: item.text,
        };

        const key = `columns[${formatData.dataField}][label]`;
        if (formatData.dataField === "dshdon") {
          let expandFields = [
            "ttchung_shdon",
            "ttchung_khhdon",
            "ttchung_nlap",
            "mcqtcap",
            "ldo",
          ];
          for (const item of expandFields) {
            formatDataHandle(objectExport, item);
          }
        } else {
          formatDataHandle(objectExport, formatData.dataField);
          const value = formatData.text;
          objectExport[key] = value;
        }
        return formatData;
      });
    return objectExport;
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.columnFilter = columnFilter;
    params.page = page;
    params.sizePerPage = sizePerPage;
    fetchList(params);
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    fetchList(params);
  };

  const optionShowColumnHandel = (field, value) => {
    const targetColumn = columns.find(item => item.dataField === field);
    if (targetColumn) {
      targetColumn.hidden = !value;
    }
    setColumns(columns);
    dispatch(setColumnVisibleRegistryInvoices(field, value));
  };

  useEffect(() => {
    switch (typePDF) {
      case DOWNLOAD_PDF_REGISTRY_INVOICES_SUCCESS: {
        if (fileDownloadPDF !== null) {
          const link = document.createElement("a");
          link.href = fileDownloadPDF;
          link.setAttribute(
            "download",
            fileDownloadNamePDF || "Error-invoice.pdf"
          );
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetdownloadPDFInvoices());
        break;
      }
      case DOWNLOAD_PDF_REGISTRY_INVOICES_FAIL: {
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetdownloadPDFInvoices());
      }
      default:
        break;
    }
  }, [typePDF]);

  useEffect(() => {
    if (buStoreHeader) {
      console.log("Có thông tin đơn vị hiện tại, khởi tạo các cột", {
        buStoreHeader,
      });
      initColumn();
    }
  }, [buStoreHeader]);

  return (
    <React.Fragment>
      {/* <AutoReloadList
        listData={listData}
        dataCheck={bkDataNew}
        actionReset={() => {
          dispatch(resetBackupDataNew());
        }}
        actionReload={() => {
          fetchList(params);
        }}
      /> */}
      {/* delete modal */}
      <ConfirmModal
        isOpen={modalConfirmDelete}
        titleHeader={"Xác nhận xóa thông báo"}
        titleBody={"Hệ thống sẽ thực hiện xóa thông báo này ?"}
        isDisableButton={errorInvoicesDeleteData.loading}
        onConfirm={note => {
          dispatch(errorInvoicesDelete(dataViewDocument.id, isTaxDeduct));
        }}
        textBtnConfirm={"Xác nhận"}
        textBtnCancel={"Đóng"}
        toggle={toggleConfirmDeleteModal}
      />
      {/* Hình thức ký modal */}
      <TypeSignDigitalModal
        t={t}
        isOpen={modalTypeSign}
        downloadXmlFunc={downloadXmlErrorInvoices}
        transferData={transferData}
        toggle={toggleTypeSignModal}
        toggleUSBSignModal={toggleUSBSignModal}
        toggleHSMSignModal={toggleHSMSignModal}
      />
      {/* Ký USB Modal */}
      <VerifyPinUSBModal
        t={t}
        isOpen={modalUSBSign}
        transferData={transferData}
        resetDataFunc={getListErrorInvoices}
        params={{
          ...params,
          isTaxDeduct,
        }}
        toggle={toggleUSBSignModal}
      />
      {/* Ký HSM Modal */}
      <SignHSMModal
        t={t}
        isOpen={modalHSMSign}
        transferData={transferData}
        resetDataFunc={getListErrorInvoices}
        releaseFunc={releaseErrorInvoices}
        resetReleaseFunc={resetReleaseErrorInvoices}
        params={{
          ...params,
          isTaxDeduct,
        }}
        toggle={toggleHSMSignModal}
      />
      {/* ErrorReleaseModal */}
      <ErrorReleaseModal
        isOpen={modalErrorRelease}
        toggle={toggleErrorReleaseModal}
        id={idRelease}
        path={isTaxDeduct ? "tax-deduct-errors" : "invoice-errors"}
      />
      {/* PDFViewModal */}
      <PDFViewModal
        isOpen={modalPdfView}
        dataViewDocument={dataViewDocument}
        toggle={togglePdfViewModal}
        isTaxDeduct={isTaxDeduct}
      ></PDFViewModal>
      <HistoryTransferModal
        isOpen={modalHistoryTransfer}
        toggle={toggleHistoryTransferModal}
        id={idHistory}
        path={isTaxDeduct ? "tax-deduct-errors" : "invoice-errors"}
      />
      <ListHDonModal
        dataListHDon={dataListHDon}
        isOpen={modalListHDon}
        toggle={toggleListHDonModal}
        isTaxDeduct={isTaxDeduct}
      />
      <DetailDataModal
        detailData={detailData}
        isOpen={modalDetail}
        toggle={toggleDetailModal}
      />
      <DetailDataModalV2
        isTaxDeduct={true}
        detailData={detailDataTaxDeduct}
        isOpen={modalDetailDataTaxDeduct}
        toggle={toggleDetailDataTaxDeductModal}
      />
      <div className="page-content">
        <MetaTags>
          <title>{`Danh sách ${object} sai sót`}</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={`Danh sách ${object} sai sót (${totalCount})`}
            breadcrumbItems={[
              { name: `Thông báo ${object} sai sót` },
              { name: `Danh sách ${object} sai sót` },
            ]}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <React.Fragment>
                    <RemoteDataTable
                      keyField="id"
                      data={listData}
                      columns={columns}
                      page={params.page}
                      listMultipleRowAction={listMultipleRowAction}
                      listRowAction={listRowAction}
                      sizePerPage={params.sizePerPage}
                      totalSize={totalCount}
                      loading={loading}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandel}
                      rowEvents={rowEvents}
                    >
                      <Button
                        type="button"
                        color="primary"
                        className="me-2 btn-label"
                        onClick={() => {
                          history.push(
                            `/${
                              isTaxDeduct
                                ? "error-tax-deducts/create"
                                : "error-invoices/create"
                            }`
                          );
                        }}
                      >
                        <i className="bx bx-plus label-icon" />
                        Thêm mới
                      </Button>
                    </RemoteDataTable>
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

ListData.propTypes = {
  isTaxDeduct: PropTypes.bool,
};

export default ListData;
